export default "__VITE_ASSET__WZcD9zvd__"